<template>
    <MainView></MainView>
</template>

<style scoped>
	@import url('../assets/resource/css/main.css');
</style>
<script>

import MainView from "../components/main/Main.vue";

export default {
components: {
    MainView
  },
}
</script>